import { FC, ReactNode } from 'react'

import { Skeleton, Stack, Typography } from '@mui/material'

import { Game, GameIcon } from '../../../../../features/game'

type FtueGameHeaderProps = {
  game?: Game
  isLoading?: boolean
  children?: ReactNode
}

export const FtueGameHeader: FC<FtueGameHeaderProps> = ({ game, isLoading, children }) => {
  if (isLoading) return <Skeleton variant="rectangular" height={64} />
  if (!game) return null
  return (
    <Stack direction="row" spacing={2} alignItems="center" data-testid="ftue-game-header">
      <GameIcon src={game.getIcon() as string} gameName={game.resolvedName || game.name || ''} size="normal" />
      <Stack flexGrow={1}>
        <Typography variant="h6" fontWeight="bold">
          {game.resolvedName || game.name || '---'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {game.artist || '---'}
        </Typography>
      </Stack>
      {children}
    </Stack>
  )
}
